import InfoButton from "@teamscheme/info-button";
import styled from "styled-components";

const StyledInfoButton = styled(InfoButton)`
  display: inline-block;
  vertical-align: sub;
`;

export default StyledInfoButton;
